module.exports = __webpack_public_path__ + "img/social-github.c5c260b.svg";